/* eslint-disable import/no-extraneous-dependencies, import/prefer-default-export */
import { writable } from 'svelte/store';
import { HumanFileSize, parseDate } from '../../utils/conv';
import { headerDisplayStore } from '../General';
import { sendFileFormDataRequest } from '../../api/crud';
// import { parse } from 'uuid';
//import { parseCSV } from './parseAssteCSV';

const initState = { files: {}, size: 0, loaded: 0, isDone: false, dbUpload: false, progress: 0, showBar: false, showModal: false }
const { subscribe, set, update } = writable({ ...initState });
const obj = {
  subscribe,
  update,
  SaveToDB: async (data, files) => {
    set({ files });
    try {
      let response = await create('topper/videos', data);
      if (response?.status === 'ok') {
        update((s) => {
          s.dbUpload = true;
          return s;
        });
        //start uploading here
        let checkupload = await obj.SetFiles(files);
        console.log(checkupload);
      } else {
        update((s) => {
          s.dbUpload = false
          return s;
        })
      }
    } catch (error) {
      console.error('Error:', error);
      headerDisplayStore.ShowError({
        title: 'Video creation error',
        subtitle: 'Failed to upload video',
      });
      update((s) => {
        s.isDone = true;
        return s;
      });
    }
  },
  AddToTotalSize: (delta) => {
    update((s) => {
      s.loaded += delta;
      s.progress = parseFloat((s.loaded * 100) / s.size).toFixed(1);
      return s;
    });
  },
  SetFiles: async (formData, data, callback) => {
    //let uploading = {}
    window.onbeforeunload = () => window.confirm("Exiting the page will interrupt the bulk upload.\nAre you sure you want exit?")

    const files = formData.getAll("files");
    const fileNames = []
    for (const file of files) {
     // console.log(file.name);
      fileNames.push(file.name)
    }

    update(s => { return { ...s, files: data, size: data.length, progress: 0, showBar: true } });
    // loop over csv data object
    for (const [index, csvLine] of data.entries()) {
      const { original_filename } = csvLine
      // validating filename existance 
      const fileIndex = fileNames.indexOf(original_filename)
      // prompt error if assetFile not exists in folder - TODO
      const fileUpdate = false//fileIndex < 0 && csvLine.asset_url
      const assetFile = files[fileIndex]
      // support date parsing
      const { start_date, end_date } = csvLine
      // csvLine['title'] = title.toLowerCase()
      
      csvLine['start_date'] = parseDate(start_date)
      csvLine['end_date'] = parseDate(end_date)
      // extract 'lastModifiedDate' from file if exists
      if (assetFile) {
        const { lastModifiedDate } = assetFile
        csvLine['update_at'] = parseDate(lastModifiedDate)
      }

      // upload assetFile with csvLine data into API
      const formData = new FormData();
      formData.append("files", assetFile);
      formData.append("data", JSON.stringify(csvLine));
      try {
        if(csvLine.blockingErr){
          throw csvLine.blockingErr
        }
        if (fileIndex < 0) { // && !fileUpdate) {
          throw `'${original_filename}' file is missing`
        }
        const response = await sendFileFormDataRequest(
          "/topper/upload/single",
          formData,
          "formData"
        );
        if(response.warnings.length){
          headerDisplayStore.ShowNotification({
            title:'Warning in file upload for ' + data[index].title,
            subtitle: response.warnings,
            color:'warning'
          })     
        }
        // test with -> response = await new Promise((res) => setTimeout(() => res("p1"), 12000));
        update((s) => {
          s.files[index] = response.topper || assetFile
          s.files[index].state = { error: false, warningMsgs:response.warnings, updated: fileUpdate, message: fileUpdate ? 'Asset data updated' : "Successfully uploaded" }
          s.progress++
          return s
        })
      } catch (err) {
        let errorMessage;
        try {
          errorMessage = JSON.parse(err.message).errors
        } catch (e) {
          errorMessage = err
        }
        update((s) => {
          s.files[index].state = { error:true, message: errorMessage }
          s.progress++;
          return s;
        })
  
          headerDisplayStore.ShowError({
            title: 'Error in file upload for ' + data[index].title,
            subtitle: errorMessage
          });
      
      }
      // update loader state with progress
    }
    update(s => {
      s.isDone = true;
      s.showModal = true;
      s.showBar = false
      return s
    })
    window.onbeforeunload = null
    callback()
  },
  TopperSet: async (data) => {
    var video = {
      filename: data[0].name,
      title: data[0].title,
      description: data[0].description,
      id: data[0].id,
    };
    obj.SaveToDB(
      [
        {
          topper_id: video.id,
          title: video.title ? video.title : video.filename, //assign title if not empty, but if emtpty the filename will be used
          asset_url: 'https://static.originmedia.tv/topper/' + video.id + '.mp4',
          thumbnail_url: 'https://static.originmedia.tv/cms/' + video.id + '/thumb.jpg',
          description: video.description,
          hash: video.id,
        },
      ],
      data
    );
  },
  reset() {
    set({ ...initState })
  }
};
export default obj;